/** Textes « fileHorsLigne » — le français fait foi. */
export const fileHorsLigne = {
  reconnectezTitre: (n: number) => `Reconnectez-vous pour envoyer ${n} saisie(s)`,
  reconnectezTexte: "Votre session a expiré pendant que l'appareil était hors ligne.",
  rienPerdu: " Rien n'est perdu",
  rienPerduSuite: ' : les saisies et leurs photos sont conservées ici.',
  refusesTitre: (n: number) => `${n} saisie(s) refusée(s) par le serveur`,
  refusesTexte: 'Elles sont conservées sur cet appareil. Lisez le motif ci-dessous : personne ne les supprimera à votre place.',
  attenteTitre: (n: number) => `${n} saisie(s) en attente d'envoi`,
  attenteTexte: 'Elles sont conservées sur cet appareil et partiront dès que la connexion sera stable.',
  masquer: 'Masquer',
  voir: 'Voir',
  envoi: 'Envoi…',
  envoyer: 'Envoyer maintenant',
  colSaisie: 'Saisie',
  colCreee: 'Créée le',
  colEssais: 'Essais',
  refusee: 'Refusée',
  confirmerAbandon: (libelle: string) => `Abandonner definitivement « ${libelle} » ? Cette saisie et ses photos seront perdues.`,
  abandonner: 'Abandonner',
  /** Messages de la file (lib/offline). */
  sessionExpiree: 'Session expiree — reconnectez-vous, la saisie repartira ensuite.',
  refusServeur: (code: number) => `Refus du serveur (${code})`,
};
